import { render } from "./LanguageButton.vue?vue&type=template&id=496e416b&ts=true"
import script from "./LanguageButton.vue?vue&type=script&lang=ts"
export * from "./LanguageButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__